import React from 'react';

function BooleanToggle({ id, label, checked, onChange, disabled }) {
  return (
    <div className="mb-3">
      <label className="form-label d-block">{label}</label>
      <div className="status-toggle modal-status">
        <input
          type="checkbox"
          id={id}
          className="check"
          checked={!!checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
        />
        <label htmlFor={id} className="checktoggle" />
      </div>
    </div>
  );
}

function ProductHomePageSectionDetailsFields({ formData, sendDataToParent, readOnly = false }) {
  const propagate = (next) => {
    if (sendDataToParent) sendDataToParent(next);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    propagate({ ...formData, [name]: value });
  };

  const handleToggle = (name, checked) => {
    propagate({ ...formData, [name]: checked });
  };

  if (readOnly) {
    return (
      <div className="row">
        <div className="col-lg-6 mb-2"><strong>Section Name:</strong> {formData.SectionName || '-'}</div>
        <div className="col-lg-6 mb-2"><strong>Display Order:</strong> {formData.DisplayOrder ?? 0}</div>
        <div className="col-lg-6 mb-2"><strong>Active:</strong> {formData.IsActive ? 'Yes' : 'No'}</div>
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-lg-6">
        <div className="mb-3">
          <label className="form-label">
            Section Name<span style={{ color: 'red' }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="SectionName"
            value={formData.SectionName || ''}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="col-lg-6">
        <div className="mb-3">
          <label className="form-label">Display Order</label>
          <input
            type="number"
            className="form-control"
            name="DisplayOrder"
            value={formData.DisplayOrder ?? 0}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="col-lg-6">
        <BooleanToggle
          id={`IsActive-${formData.ProductHomePageSectionId || 'new'}`}
          label="Active"
          checked={formData.IsActive}
          onChange={(v) => handleToggle('IsActive', v)}
        />
      </div>
    </div>
  );
}

export default ProductHomePageSectionDetailsFields;
